import React, { useState } from "react";
import { Formik, Form, useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { ForgotPasswordModel } from "../model/utilModels/ForgotPasswordModel";
import { ForgotPasswordSchema } from "../validations/Schema";
import { UtilService } from "../services/shared/UtilService";
import { msgTypes } from "../constants/msgTypes";
import { MuiInput } from "../components/basicComponent/MuiInput";
import MuiButton from "../components/basicComponent/MuiButton";
import { useSweetAlert } from "../services/customHooks/useSweetAlert";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

const ForgetPassword = () => {
  const navigate = useNavigate();
  const [isEmailSend, setIsEmailSend] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const initialValues = { email: "" };
  const { showSuccess } = useSweetAlert();
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: ForgotPasswordSchema,
    onSubmit: (values, formikHelpers) => {
      onSubmit(values, formikHelpers);
    },
  });
  const onSubmit = async (
    values: ForgotPasswordModel,
    { resetForm }: { resetForm: () => void }
  ) => {
    try {
      const requestData = new ForgotPasswordModel();
      requestData.email = values.email;
      setIsLoading(true);
      const res = await UtilService.forgotPassword(requestData);
      if (res.statusMsg === msgTypes.SUCCESS.msg) {
        // resetForm();
        formik.resetForm();
        setIsLoading(false);
        setIsEmailSend(true);
        showSuccess(
          "Success!",
          "If an account exists with the provided email, you'll receive a password reset link shortly."
        ).then((result) => {
          if (result.isConfirmed) {
            navigate("/"); // Or any other logic
          }
        });
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Forgot Password Error:", error);
    }
  };

  return (
    <main
      style={{ backgroundColor: "#fff" }}
      className="grow h-full d-flex content px-4 login-page "
      id="content"
      role="content"
    >
      <div className=" triangle-top-right">
        <img src="media/images/Group.png" alt="Group.png" />
      </div>
      <div className="login-container">
        <div className="decorative-triangle triangle-top-left"></div>
        <div className="login-form-section">
          <div className="logo-section m-auto mb-0">
            <img src="media/images/ewts-logo-(1).png" alt="logo" />
          </div>
          <div className="form-container m-auto mt-n3">
            <h2 className="form-title pt-0">Forget Password</h2>

            <div className="input-group login-error-msg">
              <MuiInput
                placeholder="Enter Email"
                isRequired={true}
                isInvalid={formik.touched.email && !!formik.errors.email}
                errorText={formik.errors.email}
                onChange={(value) =>
                  formik.handleChange({
                    target: { name: "email", value },
                  })
                }
                onBlur={formik.handleBlur}
                iconStart={<MailOutlineIcon />}
              />
            </div>
            <div className="d-flex justify-content-center">
              <MuiButton
                className="login-button"
                label="Send"
                // disabled={!formik.dirty || !formik.isValid}
                isLoading={isLoading}
                onClick={() => formik.handleSubmit()}
              />
            </div>
            <div className="forget-password text-center pt-4">
              <MuiButton
                className="back-btn "
                label="Back to login"
                type="submit"
                onClick={() => navigate("/")}
                startIcon={<KeyboardBackspaceIcon />}
              />
            </div>
          </div>
        </div>

        <div className="image-section">
          {/* <div className="image-overlay"></div> */}
          <img src="./media/images/login-side-img.png" alt="login-side-img" />
        </div>
      </div>
    </main>

    // <main
    //   className="grow h-full d-flex content px-4 onboarding-sec"
    //   id="content"
    //   role="content"
    // >
    //   <div className="card forget-pass  login-form-sec">
    //     <div className="onboard-logo">
    //       <img src="media/images/ewts-logo.png" alt="logo" />
    //     </div>
    //     <h3 className="card-title pb-2"> Forget Password</h3>
    //     <span className="text-2sm text-gray-700  forget-pass-title ">
    //       Enter your email to reset your password
    //     </span>
    //     <div className="card-body flex flex-col justify-end items-stretch grow  ">
    //       <div className="row">
    //         <div className="col-md-12">
    //           {/* ✅ Wrap with Formik */}

    //           <MuiInput
    //             label="Email"
    //             placeholder="Enter Email"
    //             isRequired={true}
    //             isInvalid={formik.touched.email && !!formik.errors.email}
    //             errorText={formik.errors.email}
    //             onChange={(value) =>
    //               formik.handleChange({
    //                 target: { name: "email", value },
    //               })
    //             }
    //             onBlur={formik.handleBlur}
    //           />

    //           {/* ✅ Button now submits the form */}
    //         </div>
    //         <div className="col-md-12">
    //           <div className="user-button mt-4">
    //             <MuiButton
    //               className="clear-btn"
    //               label="Back"
    //               type="submit"
    //               onClick={() => navigate("/")}
    //               style={{ width: " -webkit-fill-available" }}
    //             />
    //             <MuiButton
    //               className="get-btn"
    //               label="Send"
    //               type="submit"
    //               disabled={!formik.dirty || !formik.isValid}
    //               isLoading={isLoading}
    //               onClick={() => formik.handleSubmit()}
    //               style={{ width: " -webkit-fill-available" }}
    //             />
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </main>
  );
};

export default ForgetPassword;
